
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

var Expense2Page = Vue.extend({})
Vue.component('expense2-page', Expense2Page)

export default {
  name: 'Expense2Page',
  components: {
    XTable,XButton
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      info: {},
      otherMap: {}
    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl+'/wechat/expense/getExpenseJson/'+this.idArr[0],
      method: 'get'
    }).then((response) => {
      this.info = response.data.data.info;
      this.otherMap = response.data.data.otherMap;
    }).catch((response) => {
    });
  },
  methods: {
    showImg (src) {
      if(Object.keys(this.otherMap).length == 0){
        this.$vux.alert.show({
          title: '暂无数据'
        });
        setTimeout(() => {
          this.$vux.alert.hide();
        }, 2000)
      }else{
        let imgSrc = this.otherMap['image'+src]+'?number='+Math.random();
        let imgSrcArr = [];
        imgSrcArr.push(imgSrc);
        wx.previewImage({
          current: imgSrc, // 当前显示图片的http链接
          urls: imgSrcArr // 需要预览的图片http链接列表
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/finance/expense2.vue